// extracted by mini-css-extract-plugin
export default {"table-container":"ChargePointTable_table-container__Objdq","ka-row":"ChargePointTable_ka-row__y6nf1","row-problem":"ChargePointTable_row-problem__-4amb"};